import { api } from "./client"; // your existing axios instance

// engagement_id is required by the backend — scoring config is scoped to
// one engagement, not the whole org (see GetScoringConfigQuery), matching
// repoApi.js's list() shape.
export const scoringApi = {
  get: (engagementId) =>
    api.get("/codebase/scoring", { params: { engagement_id: engagementId } }),
  update: (engagementId, payload) =>
    api.put("/codebase/scoring", { ...payload, engagement_id: engagementId }),
};
